import Home from "../pages/Home";
import About from "../pages/About";
import { Navigate } from "react-router-dom";
import Stocks from "../pages/Stocks";
import Blog from "../pages/Blog";
import News from "../pages/News";
import Contact from "../pages/Contact";
import ServiceDetails from "../pages/ServiceDetails";
import NewsDetails from "../pages/NewsDetails";
import Report from "../pages/Report";

const publicRoutes = [
  { path: "/", component: <Home /> },
  { path: "/about", component: <About /> },
  { path: "/stocks", component: <Stocks /> },
  // { path: "/blog", component: <Blog /> },
  { path: "/news", component: <News /> },
  { path: "/contact", component: <Contact /> },
  { path: "/service-details", component: <ServiceDetails /> },
  { path: "/news-details/:id", component: <NewsDetails /> },
  { path: "/reports", component: <Report /> },
  // {
  //   path: "/",
  //   exact: true,
  //   component: <Navigate to="/index" />,
  // },
  // { path: "*", component: <Navigate to="/index" /> },
];

export { publicRoutes };
